import { createStore, applyMiddleware, compose } from 'redux'
import createRavenMiddleware from 'raven-for-redux'
import Raven from 'raven-js'
import ReduxThunk from 'redux-thunk'
import Reducer from './rootReducer'
import { loadState } from './localStorage'

Raven.config(process.env.REACT_APP_RAVEN).install()

const persistedState = loadState()

export default createStore(
  Reducer,
  persistedState,
  compose(
    applyMiddleware(
      ReduxThunk,
      createRavenMiddleware(Raven),
    ),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f => f),
  ),
)



// WEBPACK FOOTER //
// ./src/utils/store.js